

import request from '../utils/request'
/************************ 图书 **************************/
//资源-图书列表-图书详情
export const getBookInfo = (oid) => {
  return request({
    url: `resource/fg/ebook/get/${oid}`,
    method: 'get',
  })
}
// 图书阅读器 - 根据图书Id、章节Id、目录排序获取正文内容
export const getEBookContent = (params) => {
  const { bookId, markId, orderNum } = params
  return request({
    url: 'resource/fg/article-library/get',
    method: 'get',
    params: { ...params }
  })
}










// WEBPACK FOOTER //
// ./src/Epub/api/resource.js